import React from 'react';
import $ from 'jquery';

class Welcome extends React.Component{

	componentDidMount(){
        $("body").css("overflow", "hidden");
        // var colors = [[26,35,126], [40,53,147],[48,63,159], [57,73,171], [63,81,181], [92,107,192], [29, 41, 81]].reverse();

        // var step = 0;
        // //color table indices for:
        // // current color left
        // // next color left
        // // current color right
        // // next color right
        // var colorIndices = [0,1,2,3];

        // //transition speed
        // var gradientSpeed = 0.004;

        // function updateGradient(){

        //     if ( $===undefined ) return;

        //     var c0_0 = colors[colorIndices[0]];
        //     var c0_1 = colors[colorIndices[1]];
        //     var c1_0 = colors[colorIndices[2]];
        //     var c1_1 = colors[colorIndices[3]];

        //     var istep = 1 - step;
        //     var r1 = Math.round(istep * c0_0[0] + step * c0_1[0]);
        //     var g1 = Math.round(istep * c0_0[1] + step * c0_1[1]);
        //     var b1 = Math.round(istep * c0_0[2] + step * c0_1[2]);
        //     var color1 = "rgb("+r1+","+g1+","+b1+")";

        //     var r2 = Math.round(istep * c1_0[0] + step * c1_1[0]);
        //     var g2 = Math.round(istep * c1_0[1] + step * c1_1[1]);
        //     var b2 = Math.round(istep * c1_0[2] + step * c1_1[2]);
        //     var color2 = "rgb("+r2+","+g2+","+b2+")";

        //     $('.welcome')
        //         .css({background: "-webkit-gradient(linear, to bottom, from("+color1+"), to("+color2+"))"})
        //         .css({background: "linear-gradient(to bottom,"+color1+" 0%, "+color2+" 100%)"});

        //     step += gradientSpeed;
        //     if ( step >= 1 )
        //     {
        //         step %= 1;
        //         colorIndices[0] = colorIndices[1];
        //         colorIndices[2] = colorIndices[3];

        //         //pick two new target color indices
        //         //do not pick the same as the current one
        //         colorIndices[1] = ( colorIndices[1] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length;
        //         colorIndices[3] = ( colorIndices[3] + Math.floor( 1 + Math.random() * (colors.length - 1))) % colors.length;

        //     }
        // }

        // setInterval(updateGradient, 5);
		setTimeout(function() {
			$('.welcome').animate({
				opacity: 0,
                display: "none",
                zIndex: "-1"
			}, 400, "linear", function() {
                $("body").css("overflow", "visible");
			});
		}, 4500);

	}

	render(){
        let company = this.props.logo;
		return(
            <div className="welcome">
                <img src={require("../assets/img/" + company + ".png").default} alt="" />
                {
                    company === "hg"
                        ? <h1>Knowledge through genetics</h1>
                        : <p>Powered by <b>HeartGenetics</b> Genetics & Biotechnology, S.A.</p>
                }
            </div>
        );
    }
}
export default Welcome;

/*
*/
